<template>

    <div class="list-item" :class="classes">
        <slot></slot>
    </div>

</template>

<style scoped lang="scss">

    .list-item {
        align-items: center;
        background: #fff;
        border: 1px solid $color-rule;
        border-radius: 5px;
        box-sizing: border-box;
        display: grid;
        grid-auto-columns: 1fr;
        grid-auto-flow: column;
        grid-gap: 10px;
        line-height: normal;
        .grid {
            align-items: center;
            display: grid;
            grid-auto-columns: 1fr;
            grid-auto-flow: column;
            grid-gap: 10px;
        }
        span {
            @include font-medium(14px);
            color: $color-text;
            line-height: 1.6em;
            a {
                color: $color-primary;
                text-decoration: none;
                &:hover {
                    color: $color-primary-hover;
                }
            }
        }
        &.list-item-sm {
            padding: 10px 15px;
            span {
                font-size: 13px;
                &.small, &.small > span {
                    font-size: 12px;
                }
            }
        }
        &.list-item-lg {
            padding: 20px;
            span {
                font-size: 14px;
                &.small, &.small > span {
                    font-size: 13px;
                }
            }
        }
    }

</style>

<script>

export default {

    props: {
        size: {
            type: String,
            default: 'lg',
        },
    },

    computed: {

        classes() {
            return {
                'list-item-sm': this.size === 'sm',
                'list-item-lg': this.size === 'lg',
            }
        },

    },

}

</script>